import { FC } from 'react';
import { Checkbox, CheckboxProps } from 'antd';
import css from './policyCheck.module.scss';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';
import { getPrivacyPolicy } from '@/utils/common';

const PolicyCheck: FC<{ onCheckChange: CheckboxProps['onChange']; terms?: string; policy?: string; textCode?: string }> = (props) => {
    const { Link, useRouter, isMobile } = useGlobal();
    const { t } = useLang('shared');
    const { locale } = useRouter();
    const href = `https://${locale}.ecoflow.com/policies/terms-of-service`;
    const policyHref = getPrivacyPolicy(locale);

    const getDataLayer = (type: string) => {
        return {
            event: 'uaEvent',
            event_name: 'EcoFlow activity submit terms',
            button_name: type,
        };
    };

    return (
        <Checkbox className={`${css.policyCheck} policy-check ${isMobile ? 'policy-check-h5' : ''}`} onChange={props.onCheckChange}>
            <p className="policy-check-text">
                {t.rich(props?.textCode || 'policyCheck', {
                    use: (text: string) => (
                        <Link target="_blank" href={props?.terms || href} dataLayer={getDataLayer(text)}>
                            <span className="link-text">{text}</span>
                        </Link>
                    ),
                    policy: (text: string) => (
                        <Link target="_blank" href={props?.policy || policyHref} dataLayer={getDataLayer(text)}>
                            <span className="link-text">{text}</span>
                        </Link>
                    ),
                })}
            </p>
        </Checkbox>
    );
};

export default PolicyCheck;
